(function() {
'use strict';

angular
    .module('dashboard')
    .controller('DashboardBookings', DashboardBookings);

function DashboardBookings(
    currentUser,
    $location,
    $interpolate,
    dashboardBookingService,
    $routeParams,
    resourceService,
    dateUtil,
    crossSellService,
    onlineCheckinService,
    preferences,
    dashboardBookingsErrorMessage,
    dashboardNotificationService,
    scrollService,
    $q,
    imageService,
    mybTrack,
    dashboardCsrService,
    enumService) {
    if (!$routeParams.bookingId && $routeParams.bookingPeriod !== 'current' && $routeParams.bookingPeriod !== 'previous') {
        $location.path('dashboard/bookings/current');
    }

    const cm = this;

    if ($routeParams.selectBooking) {
        cm.selectBooking = true;
        cm.bookingSelected = bookingSelected;
        cm.redirectUrlPostBookingSelect = $routeParams.redirectUrlPostBookingSelect;
        cm.previousBookings = `dashboard/bookings/previous/selectbooking/${cm.redirectUrlPostBookingSelect}`;
        cm.currentBookings = `dashboard/bookings/current/selectbooking/${cm.redirectUrlPostBookingSelect}`;
    } else {
        cm.previousBookings = 'dashboard/bookings/previous';
        cm.currentBookings = 'dashboard/bookings/current';
    }

    cm.user = currentUser.get();
    cm.translateActionLink = translateActionLink;

    cm.limitBooking = dashboardBookingService.getLimitBooking();
    cm.next = next;
    cm.actionLink = dashboardBookingService.getActionLinks();
    cm.getResourceValue = resource => resourceService.get(resource);
    cm.setExpandedTrip = setExpandedTrip;
    cm.addDays = dateUtil.todayPlus;
    cm.bookCrossSell = bookCrossSell;
    cm.bookingType = dashboardBookingService.getBookingTypeMap();
    cm.formatBookingMessage = dashboardBookingService.formatBookingMessage;
    cm.getCrossSellTeaserText = getCrossSellTeaserText;
    cm.getCrossSellStartingFromText = getCrossSellStartingFromText;
    cm.getTripTitle = dashboardBookingService.getTripTitle;
    cm.getCrossSellTitle = getCrossSellTitle;
    cm.getTripDateText = dashboardBookingService.getTripDateText;
    cm.actionClick = dashboardBookingService.actionClick;
    cm.getFuturePayments = dashboardBookingService.getFuturePayments;

    const pageSize = 10;
    cm.bookingStatus = dashboardBookingService.getBookingStatus();

    cm.loadingBooking = true;

    const trackEvent = {
        current: 'MYB - Current Booking',
        previous: 'MYB - Previous Booking'
    };
    if (trackEvent[$routeParams.bookingPeriod]) {
        mybTrack.track(trackEvent[$routeParams.bookingPeriod]);
    }

    $q.all([
        preferences.get('canceledBooking'),
        dashboardBookingService.getOutstandingTrips($routeParams.bookingPeriod, $routeParams.bookingId, true)
    ]).then(function(results) {
        const showCanceledBookings = results[0];
        cm.loadingBooking = false;
        cm.trips = results[1];
        if (showCanceledBookings === false) {
            cm.trips = dashboardBookingService.removeCanceledBookings(cm.trips);
        }
        if (TRPCONFIG.Domain.FlightCheckinEnabled && $routeParams.bookingPeriod === 'current') {
            onlineCheckinService.addCheckinData(cm.trips);
        }
        cm.bookingNotYoursId = dashboardBookingsErrorMessage.getMessage();
        if (cm.bookingNotYoursId) {
            cm.bookingNotYours = true;
        }

        bookingConfirmed();

        dashboardCsrService.addCsrToBooking(cm.trips);
    });

    //Notifications
    cm.notificationClicked = notification => dashboardNotificationService.notificationClicked(notification);
    cm.formatNotification = notification => dashboardNotificationService.formatNotification(notification);
    //End notifications

    function translateActionLink(link, booking) {
        return link ? $interpolate(link)(booking) : '';
    }

    function next() {
        cm.limitBooking += pageSize;
        dashboardBookingService.setLimitBooking(cm.limitBooking);
    }

    function setExpandedTrip(tr, $event) {
        if (!tr.isExpanded) {
            tr.isExpanded = true;
            cm.trips.forEach(function(t) {
                t.isExpanded = (t.TripId === tr.TripId);
            });
            scrollService.scrollTo($event.target, { animate: true });

            const flightBooking = _.find(tr.Bookings, b => b.Type === 1);
            crossSellService.addExtrasAndCrossSells(tr);
            if (flightBooking && !flightBooking.ObjectId) {
                dashboardBookingService.getObjectFromBooking(flightBooking.BookingId).then(obj =>
                    flightBooking.ImageUrl = imageService.getDestinationImage(obj, 300, 190)
                );
            }
        }
    }

    function bookCrossSell(trip, crossSell) {
        if (crossSell) {
            mybTrack.track('MYB - Cross Sell Click', {
                ProductType: crossSell.Code
            });
        }
        if (crossSell.CrossSellType === enumService.CrossSellType.Seats ||
            crossSell.CrossSellType === enumService.CrossSellType.Baggage) {
            if (cm.actionLink) {
                const path = cm.translateActionLink(cm.actionLink[crossSell.Name], { BookingId: crossSell.BookingId });
                $location.url(path);
            }
        } else {
            crossSellService.startCrossSellJourney(trip.Bookings[0].BookingId, crossSell);
        }
    }

    function bookingConfirmed() {
        let isConfirmed = false;
        if (cm.trips.length > 0 && cm.trips[0].Bookings.length > 0) {
            isConfirmed = cm.trips[0].Bookings[0].Status === 1;
        }
        mybTrack.track('MYB - Booking Dashboard', {
            Reciepted: isConfirmed
        });
    }

    function bookingSelected(bookingId) {
        $location.path(`dashboard/${cm.redirectUrlPostBookingSelect}/${bookingId}`);
    }

    function getCrossSellTeaserText(productType) {
        return resourceService.get(`${productType.toUpperCase()}_CROSSSELL_TEASER`);
    }

    function getCrossSellStartingFromText(productType) {
        return resourceService.get(`${productType.toUpperCase()}_CROSSSELL_STARTING_FROM`);
    }

    function getCrossSellTitle(productType) {
        return resourceService.get(`${productType.toUpperCase()}_CROSSSELL_TITLE`);
    }
}
})();
